import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "TRAINED",
  title: defineMessage({
    id: "fig.quality.TRAINED.title",
    defaultMessage: `Percentage of teachers who are trained according to national standards`,
  }),
  caption: defineMessage({
    id: "fig.quality.TRAINED.caption",
    defaultMessage: `Many teachers are not trained, and in Sub-Saharan Africa, fewer are trained than in the past.`,
  }),
  source: defineMessage({
    id: "fig.quality.TRAINED.source",
    defaultMessage: `UIS database`,
  }),
};
